module.exports = __webpack_public_path__ + "media/laws-bg2.92268f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/laws-bg2.jpg
// module id = 1347
// module chunks = 57